import { TransportType } from '@/types/TransportType';

export const transportTypeTranslations: Record<TransportType, string> = {
	None: 'Sem Necessidade',
	RoundTrip: 'Ida e volta',
	Departure: 'Apenas ida',
	Return: 'Apenas volta',
};

export const getTransportTypeTranslation = (transportType: TransportType) => {
	return transportTypeTranslations[transportType]?.toUpperCase() || '';
};
export const transportTypeOptions: { label: string; value: TransportType }[] =
	Object.entries(transportTypeTranslations).map(([key, value]) => ({
		label: value,
		value: key as TransportType,
	}));
